import { ViewProvider } from '$providers/view';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

@Component({
  selector: 'page-observacao',
  templateUrl: 'observacao.html',
})
export class ObservacaoPage {

  titulo: string = "Informe a observação:";

  observacao: string = "";

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, private view: ViewProvider) {
    if (navParams.get("titulo")) {
      this.titulo = navParams.get("titulo");
    }
  }

  confirmar() {
    if (!this.observacao) {
      this.view.showMessage("É necessário informar a observação.");
      return;
    }

    this.viewCtrl.dismiss(this.observacao);
  }

  cancelar() {
    this.viewCtrl.dismiss(false);
  }
}



// WEBPACK FOOTER //
// ./src/pages/observacao/observacao.ts